import React from 'react';
import './CardGrid.css';

const CardGrid = () => {
  return (
    <div className="sg-page-wrapper">
      <section className="sg-section-container">
        {/* Header Text */}
        <div className="sg-header-content">
          <h2 className="sg-main-title">
            Connecting the world with AI agents.
            <br />
            6 billion users and counting.
          </h2>
        </div>

        {/* Main Grid Layout */}
        <div className="sg-main-grid">
          {/* Card 1: Scalable and Compliant (Spans 2 rows) */}
          <div className="sg-card sg-card-scalable">
            <div className="sg-card-content-scalable">
              <h3 className="sg-card-title-large">
                Scalable and
                <br />
                compliant
              </h3>
              <div className="sg-compliance-icons-container">
                <img
                  src="https://sendbird.imgix.net/cms/secure-and-compliant.png"
                  alt="Compliance Icons"
                  className="sg-compliance-group-icon"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* Card 2: 6 Billion+ */}
          <div className="sg-card sg-card-users">
            <div className="sg-card-content-top">
              <h4 className="sg-card-title-xl">6 billion+</h4>
              <p className="sg-card-description">End users globally</p>
            </div>
          </div>

          {/* Nested Grid for Bottom Right Cards */}
          <div className="sg-bottom-right-grid">
            {/* Card 3: 300M+ */}
            <div className="sg-card sg-card-mau">
              <div className="sg-card-content-bottom">
                <h4 className="sg-card-title-xl">300M+</h4>
                <p className="sg-card-description">Monthly active users</p>
              </div>
            </div>

            {/* Card 4: 99.9%+ */}
            <div className="sg-card sg-card-uptime">
              <div className="sg-card-content-bottom">
                <h4 className="sg-card-title-xl">99.9%+</h4>
                <p className="sg-card-description">Uptime</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CardGrid;